import { render, staticRenderFns } from "./confirmPurchaseModal.vue?vue&type=template&id=db0e08b8"
import script from "./confirmPurchaseModal.vue?vue&type=script&lang=js"
export * from "./confirmPurchaseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports